export default __webpack_public_path__ + "static/media/Milagros_Logo.f4cb6d01.png";